var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"relen"}},[_c('div',{staticClass:"comond_btn"},[_c('el-button',{on:{"click":function($event){_vm.handleSet('add', null)}}},[_vm._v("新增规格")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }